const aaa = [
	{
		path: "mendian",
		component: () => import("@/views/huotiguanli/mendian.vue"),
		meta:{title:'门店管理',keepAlive:true},
	},
	{
		path: "detail",
		component: () => import("@/views/huotiguanli/detail.vue"),
		meta:{title:'详情'},
	}
]
export default aaa;